/**
 * Télécharge un PDF protégé (Bearer token) et déclenche l'enregistrement
 * sous `filename`. Utilisé par les actions Courrier (facture nommée "<n° facture>.pdf").
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export async function downloadAuthBlob(url, filename) {
  const token = localStorage.getItem("cm_token");
  const fullUrl = url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
  const r = await fetch(fullUrl, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!r.ok) throw new Error(`Erreur téléchargement (${r.status})`);
  const blob = await r.blob();
  const u = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = u;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 5000);
}

export async function openAuthBlob(url) {
  const token = localStorage.getItem("cm_token");
  const fullUrl = url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
  const r = await fetch(fullUrl, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!r.ok) throw new Error(`Erreur PDF (${r.status})`);
  const blob = await r.blob();
  const u = URL.createObjectURL(blob);
  window.open(u, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(u), 60000);
}
